import type { Icon } from './icon-list.type';

export enum ToastTypes {
  INFO = 'info',
  SUCCESS = 'success',
  ERROR = 'error',
  WARNING = 'warning',
}
export type ToastType = `${ToastTypes}`;

export type ToastAction = {
  text: string;
  callback: () => void;
};

export type Toast = {
  title?: string;
  id: string;
  type: ToastType;
  message: string;
  action?: ToastAction;
  duration?: number;
  icon?: Icon;
};
